import { render, staticRenderFns } from "./actual_stock.vue?vue&type=template&id=befa14ae"
import script from "./actual_stock.vue?vue&type=script&lang=js"
export * from "./actual_stock.vue?vue&type=script&lang=js"
import style0 from "./actual_stock.vue?vue&type=style&index=0&id=befa14ae&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports